import videoSources from 'shared/constants/video-sources';


export const isExternalVideo = video => Boolean(video.mediaExternUrl);
export const isVideoFromComputer = ({ videoSource }) => videoSource === videoSources.COMPUTER;



// WEBPACK FOOTER //
// ./src/shared/ui-selectors/video/video-origin.js